// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1BE3b","log":"ModalInventoryLogs_log__1UZqU","date":"ModalInventoryLogs_date__2nMUn","userName":"ModalInventoryLogs_userName__3rMcO"};